import { Link } from "react-router-dom";
import { ImageIcon } from "lucide-react";
import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";

const projects = [
  { title: "Media Wall & Fireplace Build", category: "Interior Upgrades", desc: "Feature wall with mounted TV, electric fireplace and floating shelves for a clean modern living space." },
  { title: "Acoustic Panel Feature Wall", category: "Interior Upgrades", desc: "Slatted acoustic panelling installed to add warmth, texture and a premium finish." },
  { title: "Fencing & Gate Installation", category: "Outdoor Improvements", desc: "New boundary fencing and a secure gate for improved privacy and street appeal." },
  { title: "Synthetic Grass Yard Makeover", category: "Outdoor Improvements", desc: "Low-maintenance synthetic grass with fresh edging and a full yard clean-up." },
  { title: "Security Camera Upgrade", category: "Security & Access", desc: "Camera system, sensor lights and smart doorbell installed with app setup." },
  { title: "Rental Property Refresh", category: "Property Maintenance", desc: "Patch and paint, repairs and pressure washing to get a rental tenant-ready." },
];

const OurWork = () => (
  <PageLayout>
    <Seo
      title="Our Work – Oz Property Services Co. Melbourne"
      description="A selection of recent property upgrades, feature walls, fencing, security and maintenance jobs across Melbourne."
      path="/our-work"
    />
    <PageHero
      title="Our Work"
      subtitle="A selection of recent property upgrades and maintenance jobs across Melbourne."
    />
    <section className="bg-white py-16 md:py-24">
      <div className="container">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((p) => (
            <div key={p.title} className="bg-card rounded-2xl overflow-hidden flex flex-col">
              {/* Before / after image placeholders */}
              <div className="grid grid-cols-2 gap-px bg-[#1a1a1a]/5">
                {["Before", "After"].map((label) => (
                  <div key={label} className="aspect-[4/3] bg-[#FFC300]/15 flex flex-col items-center justify-center text-dark/50">
                    <ImageIcon className="w-7 h-7 mb-1.5" />
                    <span className="text-xs font-bold uppercase tracking-wide">{label}</span>
                  </div>
                ))}
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="text-xs font-bold uppercase tracking-wide text-dark/50 mb-2">{p.category}</span>
                <h2 className="text-lg font-bold text-dark mb-2">{p.title}</h2>
                <p className="text-muted-foreground text-sm leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/get-quote"
            className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
          >
            Get Free Quote
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default OurWork;
